import { render, staticRenderFns } from "./customerList.vue?vue&type=template&id=839211d2&scoped=true"
import script from "./customerList.vue?vue&type=script&lang=js"
export * from "./customerList.vue?vue&type=script&lang=js"
import style0 from "./customerList.vue?vue&type=style&index=0&id=839211d2&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839211d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('839211d2')) {
      api.createRecord('839211d2', component.options)
    } else {
      api.reload('839211d2', component.options)
    }
    module.hot.accept("./customerList.vue?vue&type=template&id=839211d2&scoped=true", function () {
      api.rerender('839211d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/user_client_management/form/add_user/components/customerList/customerList.vue"
export default component.exports